import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sidebar-header" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-content toc"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "warning"
}
const _hoisted_11 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar", { open: $props.movie, collapsed: $setup.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString($props.movie?.name), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "close-btn icon",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.toggleCollapse()))
      }, _toDisplayString($setup.collapsed ? 'account_tree' : 'close'), 1 /* TEXT */)
    ]),
    ($props.movie)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "icon",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('open-diagram')))
          }, "account_tree"),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.scrollToSection('movie-details')), ["prevent"]))
              }, "Movie Details")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.scrollToSection('Sequence')), ["prevent"]))
              }, "Sequence"),
              ($props.movie.Sequence && $props.movie.Sequence.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.movie.Sequence, (sequence) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: sequence.id
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers($event => ($setup.handleSidebarClick('Sequence', sequence.id)), ["prevent"])
                        }, _toDisplayString(sequence.name || 'Untitled Sequence'), 9 /* TEXT, PROPS */, _hoisted_4),
                        ($setup.getScenes(sequence).length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getScenes(sequence), (scene) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: scene.id
                                }, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: _withModifiers($event => ($setup.handleSidebarClick('Scene', scene.id)), ["prevent"])
                                  }, _toDisplayString(scene.name || 'Untitled Scene'), 9 /* TEXT, PROPS */, _hoisted_6),
                                  ($setup.getShots(scene).length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getShots(scene), (shot) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: shot.id,
                                            class: "shot-item"
                                          }, [
                                            _createElementVNode("a", {
                                              href: "#",
                                              onClick: _withModifiers($event => ($setup.handleSidebarClick('Shot', shot.id)), ["prevent"])
                                            }, _toDisplayString(shot.name || 'Untitled Shot'), 9 /* TEXT, PROPS */, _hoisted_8),
                                            _createElementVNode("button", {
                                              class: "icon",
                                              onClick: $event => ($setup.generateShot(shot.id))
                                            }, "camera", 8 /* PROPS */, _hoisted_9)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "No sequences"))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($props.schema).filter((f) => $props.schema[f].showForm && f != 'Sequence'), (relation) => {
              return (_openBlock(), _createElementBlock("li", { key: relation }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers($event => ($setup.scrollToSection(relation)), ["prevent"])
                }, _toDisplayString(relation), 9 /* TEXT, PROPS */, _hoisted_11)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}